import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import cacheTerms from 'helpers/cacheTerms';
import preload from 'api/data-preload';
import DataProvider from 'api/data-provider';
import seoPreload, { seoDecorator } from 'api/seo';
import Dict from 'api/data-dict';
import { marketStatEvents, mstatDecorator } from 'subsys/market-stat';
import Container from 'components/container';
import { SeoText } from 'components/layouts';
import Breadcrumbs from 'components/breadcrumbs';

import linksBildControl from 'src-sites/bildcontrol/links';

import AboutBlock from './blocks/block-about';
import OurTeam from './blocks/block-our-team';
import OurSystemBlock from './blocks/block-our-system';
import DescriptionBlock from './blocks/block-description';
import WriteUsBlock from '../blocks/block-write-us';

import translates from './about-i18n.json';

import 'styles/bildcontrol/section-about/_page-about-us.scss';

const classes = new Bem('pageAboutUs');

@preload({
  ourTeam: [DataProvider.preload, {
    url: 'common/users/our-company',
    queryJson: true,
    query: {
      key: 'bildcontrol_team',
      limit: 3
    },
    cache: cacheTerms.longInfoProvider
  }],
  livingComplexCondition: [Dict.preload, { url: 'reliability/living-complex' }],
  developerCondition: [Dict.preload, { url: 'reliability/developer' }],
  ...seoPreload({ entity: 'aboutPage' }, [])
})
@seoDecorator({
  advancedVars: {
    bottomText: 'Текст в самом низу'
  }
})
@mstatDecorator(marketStatEvents.historyChange, () => ({ entity: 'О нас' }))
@I18nHoc(translates)
export default class PageAbout extends Component {
  static propTypes = {
    className: PropTypes.string,
    location: PropTypes.shape({}),
    seoData: PropTypes.shape({}),
    livingComplexCondition: PropTypes.shape({}),
    developerCondition: PropTypes.shape({}),
    ourTeam: PropTypes.shape({})
  };

  render() {
    const { i18n } = this;
    const {
      className, location, seoData = {}, livingComplexCondition = {}, developerCondition = {}, ourTeam
    } = this.props;
    const seoLocation = get(location, 'pathname', null);
    const seoText = get(seoData, 'bottomText');
    const dataLC = livingComplexCondition.data || [];
    const dataDeveloper = developerCondition.data || [];
    const countCondition = dataLC.length + dataDeveloper.length;
    const header = seoData && seoData.header ? seoData.header : i18n('aboutH1');
    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksBildControl.sectionBildControl,
        builderProps: { title: i18n('breadcrumbsMain') }
      }, {
        name: i18n('aboutH1'),
        builder: linksBildControl.sectionAbout
      }
    ];

    return (
      <div {...classes({ extra: className })}>
        <AboutBlock
          {...classes('blockAbout')}
          {...classes('blockAbout')}
          topic={header}
          countCondition={countCondition}
        />
        <OurTeam
          {...classes('blockOurTeam')}
          ourTeam={ourTeam}
        />
        <OurSystemBlock {...classes('blockOurSystem')} />
        <DescriptionBlock {...classes('blockDescription')} />
        <WriteUsBlock {...classes('blockWriteUs')} url={seoLocation} />
        <Container body>
          <Breadcrumbs {...classes('breadcrumbs')} data={dataBreadcrumbs} />
          <SeoText data={seoText} />
        </Container>
      </div>
    );
  }
}
